import { useModalStore } from '../../../store/ModalStore'
import FriendsModal from '../FriendsModal/FriendsModal'
import styles from './NoFriendsV2.module.css'

const NoFriendsV2 = () => {

    const setOpen = useModalStore((state) => state.setOpen)
    const open = useModalStore((state) => state.open)

    const copyInviteLink = () => {
        const userId: number = window.Telegram?.WebApp.initDataUnsafe.user.id
        window.Telegram?.WebApp.openTelegramLink(`https://t.me/share/url?url=https://t.me/dreamcoin_bot?start=${userId}`)
    }

    return (
        <div>
            <div className={styles.head}>
                <div className={styles.head__text}>Твои друзья</div>
                <div className={styles.bonusContainer}>
                    <div className={styles.head__bonusIcon}></div>
                    <div onClick={() => setOpen(true)} className={styles.head__bonusText}>Бонус</div>
                </div>
            </div>
            <div className={styles.text}>
                Список пуст, приглашай друзей и получай бонусы!
            </div>
            {open && <FriendsModal/>}
        </div>
    )
}

export default NoFriendsV2